import React, { useState, useEffect } from 'react'
import {
  Panel,
  Row,
  Col,
  ControlLabel,
  Input,
  Form,
  SelectPicker,
  DatePicker,
  RadioGroup,
  Radio,
} from 'rsuite'
import { isRequired, isValidators, requiredFiled } from '../../../utils/ValidatorUtils'
import ErrorMessage from '../../../components/message/errorMessage/ErrorMessage'
import classNames from 'classnames'
import moment from 'moment'
import { DATE_PICKER_FORMAT, LOCAL_DAY_TH } from '../../../constants/date'

export default function ProjectCloseForm({
  schema: _schema,
  register,
  errors,
  error,
  Controller,
  control,
  setValue,
  clearErrors,
  getValues,
  handelPreview,
  clearValue,
  ...props
}) {
  const [schema, setSchema] = useState(_schema)
  const [startDate, setStartDate] = useState(null)
  const [endDate, setEndDate] = useState(null)
  const [fromBudgetYearOptions, setFromBudgetYearOptions] = useState(
    schema.budgetYearStartOption.options
  )
  const [toBudgetYearOptions, setToBudgetYearOptions] = useState(schema.budgetYearEndOption.options)

  useEffect(() => {
    if (!clearValue) {
      const indexOptionFromBudgetYear = schema.budgetYearEndOption.options.length - 1
      const indexOptionToBudgetYear = schema.budgetYearEndOption.options.length - 1

      setValue(
        schema.budgetYearStartOption.name,
        schema.budgetYearStartOption.options[indexOptionFromBudgetYear].value
      )
      setValue(
        schema.budgetYearEndOption.name,
        schema.budgetYearEndOption.options[indexOptionToBudgetYear].value
      )
    }
  }, [clearValue])

  const handleChangeBudgetYear = (name, value) => {
    console.log(name, value)
    if (value) {
      let bgy = getValues(name)
      if (!bgy) {
        setValue(name, value)
        clearErrors(name)
      } else if (name == schema.budgetYearStartOption.name && bgy > value) {
        setValue(name, value)
      } else if (name == schema.budgetYearEndOption.name && bgy < value) {
        setValue(name, value)
      }

      if (name == schema.budgetYearStartOption.name) {
        setFromBudgetYearOptions(
          schema.budgetYearStartOption.options.filter((e) => e.value <= value)
        )
      }

      if (name == schema.budgetYearEndOption.name) {
        setToBudgetYearOptions(schema.budgetYearEndOption.options.filter((e) => e.value >= value))
      }
    } else {
      if (name == schema.budgetYearStartOption.name) {
        setFromBudgetYearOptions(schema.budgetYearStartOption.options)
      }

      if (name == schema.budgetYearEndOption.name) {
        setToBudgetYearOptions(schema.budgetYearEndOption.options)
      }
    }
  }

  return (
    <>
      <Form id="mainContainer">
        <Row>
          <Col
            lg={4}
            md={4}
            sm={8}
            xs={8}
            style={{
              marginTop: '5px',
              padding: '8px',
              textAlign: 'right',
            }}
          >
            <ControlLabel>
              {requiredFiled(schema.startDate.validators, schema.startDate.label)}
            </ControlLabel>
          </Col>
          <Col lg={8} md={8} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
            <ErrorMessage error={errors[schema.startDate.name]} />
            <Controller
              name={schema.startDate.name}
              control={control}
              defaultValue={schema.startDate.value ? schema.startDate.value : null}
              rules={isValidators(schema.startDate.validators)}
              render={(props) => {
                return (
                  <DatePicker
                    format="DD/MM/YYYY"
                    locale={LOCAL_DAY_TH}
                    block
                    value={props.value}
                    onChange={(date) => {
                      props.onChange(date)
                    }}
                  />
                )
              }}
            />
          </Col>
          <Col
            lg={4}
            md={4}
            sm={8}
            xs={8}
            style={{
              marginTop: '5px',
              padding: '8px',
              textAlign: 'right',
            }}
          >
            <ControlLabel>
              {requiredFiled(schema.endDate.validators, schema.endDate.label)}
            </ControlLabel>
          </Col>
          <Col lg={8} md={8} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
            <ErrorMessage error={errors[schema.endDate.name]} />
            <Controller
              name={schema.endDate.name}
              control={control}
              defaultValue={schema.endDate.value ? schema.endDate.value : null}
              rules={isValidators(schema.endDate.validators)}
              render={(props) => {
                return (
                  <DatePicker
                    format="DD/MM/YYYY"
                    locale={LOCAL_DAY_TH}
                    block
                    value={props.value}
                    onChange={(date) => {
                      props.onChange(date)
                    }}
                  />
                )
              }}
            />
          </Col>
        </Row>

        <Row>
          <Col
            lg={4}
            md={4}
            sm={8}
            xs={8}
            style={{
              marginTop: '5px',
              padding: '8px',
              textAlign: 'right',
            }}
          >
            {schema.projectCode.label}
          </Col>
          <Col lg={8} md={8} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
            <Input
              name={schema.projectCode.name}
              defaultValue={schema.projectCode.value}
              placeholder={schema.projectCode.hint || `ระบุรหัสโครงการ`}
              inputRef={register()}
            />
          </Col>
          <Col
            lg={4}
            md={4}
            sm={8}
            xs={8}
            style={{
              marginTop: '5px',
              padding: '8px',
              textAlign: 'right',
            }}
          >
            {schema.projectName.label}
          </Col>
          <Col lg={8} md={8} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
            <Input
              name={schema.projectName.name}
              defaultValue={schema.projectName.value}
              placeholder={schema.projectName.hint || `ระบุชื่อโครงการ`}
              inputRef={register()}
            />
          </Col>
        </Row>

        <Row>
          {schema?.budgetYearStartOption && (
            <>
              <Col
                lg={4}
                md={4}
                sm={8}
                xs={8}
                style={{
                  marginTop: '5px',
                  padding: '8px',
                  textAlign: 'right',
                }}
              >
                {requiredFiled(
                  schema.budgetYearStartOption.validators,
                  schema.budgetYearStartOption.label
                )}
              </Col>
              <Col lg={8} md={8} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
                <ErrorMessage error={errors[schema.budgetYearStartOption.name]} />
                <Controller
                  name={schema.budgetYearStartOption.name}
                  control={control}
                  defaultValue={
                    fromBudgetYearOptions
                      ? Math.max(...fromBudgetYearOptions.map((item) => item.value))
                      : schema.budgetYearStartOption.value
                  }
                  // rules={isValidators(schema.fromBudgetYear.validators)}
                  render={(props) => {
                    return (
                      <SelectPicker
                        data={fromBudgetYearOptions}
                        // disabled={disabledValue.fromBudgetYear}
                        value={props.value}
                        block
                        placeholder={`เลือก${schema.budgetYearStartOption.label}`}
                        onChange={(value) => {
                          props.onChange(value)
                          handleChangeBudgetYear(schema.budgetYearEndOption.name, value)
                        }}
                      />
                    )
                  }}
                />
              </Col>
            </>
          )}

          {schema?.budgetYearEndOption && (
            <>
              <Col
                lg={4}
                md={4}
                sm={8}
                xs={8}
                style={{
                  marginTop: '5px',
                  padding: '8px',
                  textAlign: 'right',
                }}
              >
                {requiredFiled(
                  schema.budgetYearEndOption.validators,
                  schema.budgetYearEndOption.label
                )}
              </Col>
              <Col lg={8} md={8} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
                <ErrorMessage error={errors[schema.budgetYearEndOption.name]} />
                <Controller
                  name={schema.budgetYearEndOption.name}
                  control={control}
                  defaultValue={
                    toBudgetYearOptions
                      ? Math.max(...toBudgetYearOptions.map((item) => item.value))
                      : schema.budgetYearEndOption.value
                  }
                  // rules={isValidators(schema.budgetYearEndOption.validators)}
                  render={(props) => {
                    return (
                      <SelectPicker
                        data={toBudgetYearOptions}
                        // disabled={disabledValue.toBudgetYear}
                        value={props.value}
                        block
                        placeholder={`เลือก${schema.budgetYearEndOption.label}`}
                        onChange={(value) => {
                          props.onChange(value)
                          handleChangeBudgetYear(schema.budgetYearStartOption.name, value)
                        }}
                      />
                    )
                  }}
                />
              </Col>
            </>
          )}
        </Row>

        <Row>
          <Col
            lg={4}
            md={4}
            sm={8}
            xs={8}
            style={{
              marginTop: '5px',
              padding: '8px',
              textAlign: 'right',
            }}
          >
            {schema.staffName.label}
          </Col>
          <Col lg={8} md={8} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
            <Input
              name={schema.staffName.name}
              defaultValue={schema.staffName.value}
              placeholder={schema.staffName.hint || `ระบุรหัสนักวิชาการผู้ประสาน`}
              inputRef={register()}
            />
          </Col>
          <Col
            lg={4}
            md={4}
            sm={8}
            xs={8}
            style={{
              marginTop: '5px',
              padding: '8px',
              textAlign: 'right',
            }}
          >
            {schema.department.label}
          </Col>
          <Col lg={8} md={8} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
            <ErrorMessage error={errors[schema.department.name]} />
            <Controller
              name={schema.department.name}
              control={control}
              defaultValue={schema.department.value}
              // rules={isValidators(schema.projectDepartment.validators)}
              render={(props) => {
                return (
                  <SelectPicker
                    data={schema.department.options}
                    // disabled={disabledValue.constYear}
                    value={props.value}
                    block
                    placeholder={`เลือก${schema.department.label}`}
                    onChange={(value) => {
                      props.onChange(value)
                      // onChangeMainProject(value)
                    }}
                  />
                )
              }}
            />
          </Col>
        </Row>
      </Form>
    </>
  )
}
